import { TableField } from "../table-field";

export const fieldsLogsEventos: TableField[] = [
    { key: 'TipoLog', label: 'Tipo', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
    { key: 'DtLog', label: 'Data', tdClass: 'align-middle', thClass: 'text-center', sortable: true },
]